import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { redirectToNextRout } from '../../store/dataCapture';

class AppBootstrapComponent extends Component {
  componentDidMount() {
    this.props.redirectToNextRout();
  }

  render() {
    return <span />;
  }
}

AppBootstrapComponent.propTypes = {
  redirectToNextRout: PropTypes.func
};

const actionCreators = {
  redirectToNextRout
};

const mapDispatchToProps = (dispatch) => bindActionCreators(actionCreators, dispatch);

export default connect(null, mapDispatchToProps)(AppBootstrapComponent);
